<template>
  <div class="search-autocomplete">
    <ul>
      <li v-for="(list, index) in SuggestionList" :key="index" @click="$emit('update', list.keyword, list.type)">
        {{ list.keyword }}
        <span class="category">
          {{ $t(`COMMON.${list.type.toUpperCase()}`) }}
        </span>
      </li>
    </ul>
  </div>
</template>
<script>
import SearchService from '@/assets/services/SearchService'

export default {
  name: 'SearchAutocomplete',
  components: {},
  props: {
    keyword: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      SuggestionList: []
    }
  },
  computed: {
  },
  watch: {
    keyword(newValue) {
      if (newValue && newValue.length > 1) {
        this.getSearchSuggest(newValue)
      }
    }
  },
  methods: {
    async getSearchSuggest(keyword, lang) {
      const productName = this.$production.toLowerCase()
      const productType = (productName === 'listen') ? 'air' : productName
      let res = await SearchService.getSearchSuggest(keyword.replace(/\//g, ''), productType, lang)
      if (res && res.data) {
        const limitCount = this.$isMobile ? 8 : 10
        this.SuggestionList = res.data[0].suggest.slice(0, limitCount)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.search-autocomplete{
  position: absolute;
  width: 100%;
  top: 64px;
  z-index: 1;
  max-height: 0;
  overflow: hidden;
  transition: .4s;
  &.active{
    max-height: 600px;
  }
  ul{
    margin: 0;
    padding: 0;
    list-style: none;
    border: 1px solid $grey-f3;
    border-top: 0;
    border-radius: 0 0 12px 12px;
    overflow: hidden;
    user-select: none;
    li{
      position: relative;
      font-size: 24px;
      font-weight: normal;
      line-height: 1.63;
      color: $grey-7d;
      padding: 8px 120px 8px 60px;
      border-bottom: 1px solid $grey-f3;
      background: #fff;
      transition: .2s;
      cursor: pointer;
      .category{
        display: inline-flex;
        position: absolute;
        font-size: 24px;
        font-weight: normal;
        font-style: normal;
        line-height: 1.63;
        color: #505050;
        top: 0;
        bottom: 0;
        right: 8px;
        align-items: center;
        justify-content: center;
      }
      &:hover{
        background: $grey-f3;
      }
      &:last-child{
        border: 0;
      }
    }
  }
}

@media only screen and (min-width: 1440px) {
}

@media only screen and (max-width: 1439.98px) {
  .search-autocomplete{
    ul{
      li{
        padding: 8px 120px 8px 8px;
      }
    }
  }
}

@media only screen and (max-width: 1023.98px) {
  .search-autocomplete{
    top: 56px;
    ul{
      li{
        font-size: 20px;
        .category{
          font-size: 20px;
        }
      }
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .search-autocomplete{
    top: 44px;
    ul{
      li{
        font-size: 16px;
        padding: 8px 100px 8px 8px;
        .category{
          font-size: 16px;
        }
      }
    }
  }
}
</style>
